import "./css/app.css";
import "normalize.css";
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Routing } from "routing";
import { Provider } from "react-redux";
import { store } from "store";
import { AbilityContext, CheckSession, ability } from "modules/auth";
import { BehaviorSubject } from "rxjs";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import ReactGA from "react-ga4";
import { NiasEntityChange } from "modules/auth/components/NiasEntityChange";
import { AccessibilityProvider } from "views/AccessibilityContext";

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

export const App: React.FC = () => {
    (window as any)["analyticsSubject"] = new BehaviorSubject<AnalyticsEvent>({});

    (window as any)["analyticsSubject"].subscribe((event: AnalyticsEvent) => {
        if (!event?.label) return;
        ReactGA.initialize("G-54H57RZDM6");
        ReactGA.send("eSavjetnik_web_init2");
        ReactGA.event({
            category: "shopping",
            action: "eSavjetnik_web_event_app",
            label: "name",
        });
    });

    return (
        <QueryClientProvider client={queryClient}>
            <Provider store={store}>
                <AbilityContext.Provider value={ability}>
                    <BrowserRouter basename={process.env.PUBLIC_URL}>
                        <AccessibilityProvider>
                            <Routing />
                            <NiasEntityChange />
                        </AccessibilityProvider>
                        <CheckSession />
                    </BrowserRouter>
                </AbilityContext.Provider>
            </Provider>
            <ReactQueryDevtools position="bottom-right" />
        </QueryClientProvider>
    );
};

export interface AnalyticsEvent {
    label?: string;
    action?: string;
    category?: string;
}
